module.exports = __webpack_public_path__ + "static/media/pattern.23178d57.png";